<template>
    <div
        v-if="show_sent"
        class="p-6 text-center"
    >
        <base-svg
            name="illustration-envelope-tick"
            class="w-full max-w-2xs mb-6 mx-auto"
        />

        <h6 class="font-semibold text-lg font-normal mb-3">
            You've got mail!
        </h6>

        <p class="text-grey-darker">
            An email is on its way to you. Follow the instructions to reset your password.
        </p>
    </div>

    <password-resets-store
        v-else
        @success="onSuccess"
    >
        <recaptcha-form
            v-model="form.recaptcha"
            slot-scope="{
                sid,
                error,
                is_loading: is_saving,
                store
            }"
            @submit="store(form)"
        >
            <div class="pt-4 px-4 sm:pt-6 sm:px-6">
                <h6 class="text-center font-semibold text-lg font-normal mb-3">
                    Password reset
                </h6>

                <p class="text-grey-darker text-sm mb-6">
                    Enter your email address below and we'll send you a link to reset your password.
                </p>

                <base-alert
                    v-if="$route.query.expired"
                    level="warning"
                    class="text-left"
                >
                    <template slot="heading">Link expired</template>
                    <template slot="content">
                        <p>
                            The link you just followed to reset your password has expired. You may request another below.
                        </p>
                    </template>
                </base-alert>

                <validator-alert :sid="sid" />

                <div
                    v-if="$validator.has('recaptcha', sid)"
                    class="flex mb-3"
                >
                    <base-svg
                        name="icon-important-circle"
                        class="flex-none w-4 h-4 mr-3px fill-primary-red fill-secondary-red-lighter"
                    />

                    <span class="text-xs text-red leading-tight">
                        {{ $validator.first('recaptcha', sid) }}
                    </span>
                </div>

                <form-item
                    :sid="sid"
                    :is-required="true"
                    name="email"
                >
                    <template slot="label">Email</template>

                    <input-text
                        v-model="form.email"
                        :sid="sid"
                        :autofocus="true"
                        :disabled="is_saving"
                        name="email"
                        type="email"
                    />
                </form-item>
            </div>

            <base-form-footer
                :is-responsive="false"
                :show-required="false"
            >
                <base-button
                    :is-loading="is_saving"
                    class="btn-blue w-full"
                >
                    Sent password reset
                </base-button>
            </base-form-footer>

            <error-modal
                v-if="error && $error.is(error, { exclude: [400, 422] })"
                :error="error"
            />
        </recaptcha-form>
    </password-resets-store>
</template>

<script>
    import HeadMixin from '../../../mixins/head'
    import PasswordResetsStore from '../../../components/password-resets-store'
    import RecaptchaForm from '../../../components/recaptcha-form'

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            PasswordResetsStore,
            RecaptchaForm
        },
        data () {
            return {
                show_sent: false,
                form: {
                    recaptcha: '',
                    email: ''
                }
            }
        },
        methods: {
            head () {
                return {
                    title: 'Password reset'
                }
            },
            onSuccess () {
                this.show_sent = true
            }
        }
    }
</script>
